import { render, staticRenderFns } from "./OtherAlers.vue?vue&type=template&id=8af5826c&"
import script from "./OtherAlers.vue?vue&type=script&lang=js&"
export * from "./OtherAlers.vue?vue&type=script&lang=js&"
import style0 from "./OtherAlers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports